import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { context } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { LASUser } from '../../../db/las-user.js';
import { Permissions } from '../../../db/permissions.js';

export const getUsersByPermission = registerQuery({
  type: () => [LASUser],
  operationName: 'getUsersByPermission',
  resolve: (permission: string) => {
    return async (gqlFields: BaseQLSelectionSet<LASUser>) => {
      if (!context.serverContext) {
        const user = await CurrentUserInfo.getMyself<LASUser>()({
          roles: {
            name: 1,
            permissions: 1,
          },
        });
        if (!user) throw new Error('User not found');
        if (!user.hasPermission(Permissions.TeamPermission.VIEW)) throw new Error('User does not have permission');
      }

      const rawUsersCollection = await getRawCollection<LASUser>(LASUser._collectionName);
      const users = await rawUsersCollection
        .aggregate<LASUser>([
          {
            $lookup: {
              from: 'adornisroles',
              localField: 'roles.name',
              foreignField: 'name',
              as: 'rolesWithPermissions',
            },
          },
          {
            $match: {
              'rolesWithPermissions.permissions': permission,
            },
          },
        ])
        .toArray();
      return users;
    };
  },
  params: [{ name: 'permission', type: () => String }],
});
